import type { DeviceClass, MobileTierDecision } from '../streamRecovery/qualityContracts';
import { QUALITY_TIER_RESOLUTION, type QualityTier } from '../webrtcLatencyContracts';

const TIER_ORDER: readonly QualityTier[] = ['top', 'middle', 'bottom'];

/** Selects a device ceiling without promoting a retained recovery floor. */
export class MobileTierPolicy {
  select(input: {
    device: DeviceClass;
    connectionQuestionable?: boolean;
    retainedTier?: QualityTier;
  }): MobileTierDecision {
    let tier: QualityTier = input.device === 'desktop' ? 'top' : 'middle';
    let reason: MobileTierDecision['reason'] = input.device === 'unknown'
      ? 'unknown-safe' : input.device;
    if (input.device !== 'desktop' && input.connectionQuestionable === true) {
      tier = 'bottom';
      reason = 'constrained';
    }
    if (input.retainedTier && TIER_ORDER.indexOf(input.retainedTier) >= TIER_ORDER.indexOf(tier)) {
      tier = input.retainedTier;
      reason = 'retained-floor';
    }
    const { width: maxWidth, height: maxHeight } = QUALITY_TIER_RESOLUTION[tier];
    return { device: input.device, tier, maxWidth, maxHeight, reason };
  }
}
